import angular from 'angular'

import { makeOR, makeAND } from '../utils/bits'
import { has, noop, constant, identity, isFunction } from 'lodash-es'

angular
  .module('ggs.gallery')
  .factory('StateManager', StateManagerProvider)

function StateManagerProvider(
  qh,
  env,
  waitFor,
  StayInQueue,
  DefineMethod,
  DefineHandler) {

  return function StateManager(
    properties,
    postVoteEmitter,
    isFlowInViewportGetter,
    isFlowInViewportEmitter) {

    const sign = 'galleryMain::stateManager'
    const manager = {
      wrapM: DefineMethod(sign),
      wrapH: DefineHandler(sign)
    }

    const stayInQueue = StayInQueue(sign)

    manager.wrapM('init', () => {
      postVoteEmitter.on(manager.voteHandler)
      isFlowInViewportEmitter.on(manager.positionHandler)

      const stateAvailable = waitFor.cancellable(sign, isStateAvailable, identity).catch(qh.catchCanceled(noop))
      return stayInQueue(constant(stateAvailable.then(manager.processPosition)))
    })

    manager.wrapM('destroy', () => {
      postVoteEmitter.off(manager.voteHandler)
      isFlowInViewportEmitter.off(manager.positionHandler)

      stayInQueue.clear()
      waitFor.cancel(sign)
    })

    // voteHandler

    manager.wrapM('applyVotes', (_post, isVoted, _votesCount) => {
      if (isVoted) {
        window._app.galleriesState(properties.key).user_votes = true
      }
    })

    manager.wrapM('processVotes',
      qh.makeIf(
        makeAND(
          makeOR(
            env.getters.isHostedMode,
            env.getters.isIframelessMode),
          properties.key2get.capture_integration),
        manager.applyVotes))

    manager.wrapH('voteHandler',
      stayInQueue.make(
        manager.processVotes))

    // positionHandler

    manager.wrapM('applyAppears', () => {
      window._app.galleriesState(properties.key).gallery_appears = isFlowInViewportGetter()
    })

    manager.wrapM('processPosition',
      qh.makeIf(
        makeAND(
          makeOR(
            env.getters.isHostedMode,
            env.getters.isIframelessMode),
          properties.key2get.capture_integration),
        manager.applyAppears))

    manager.wrapH('positionHandler',
      stayInQueue.make(
        manager.processPosition))

    return manager

    // other

    function isStateAvailable() {
      return true
        && has(window, '_app.galleriesState')
        && isFunction(window._app.galleriesState)
    }
  }
}
